import { measureRouteViewport } from "@client/components/utils/RouteScroller";
import { Page } from "@client/components/utils/Page";
import { PageHeader } from "@client/components/utils/PageHeader";
import { Link } from "wouter";
import { Skeleton } from "@sfc/ui";
import { ApplicationLoading } from "./ApplicationLoading";

// Kept apart from OpenApplications.tsx (the applicant-facing preview and its
// form-guide/apply stack) so the `/apply` route's own loading skeleton, and
// the app shell's sign-in screen, don't have to pull that heavier module in
// eagerly just to render a fallback.
export function ApplicationPreviewShell({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Page
      spacing="header"
      containerClassName="max-w-7xl"
      scrollerProps={{
        "data-application-preview-scroll": true,
        ref: measureRouteViewport,
      }}
    >
      <span hidden data-application-theme="green" />
      {children}
    </Page>
  );
}

export function ApplicationPreviewLoading() {
  return (
    <ApplicationPreviewShell>
      <ApplicationPreviewLoadingContent />
    </ApplicationPreviewShell>
  );
}

export function ApplicationPreviewLoadingContent() {
  return (
    <div className="space-y-6">
      <PageHeader
        sticky
        navigation={
          <Link
            href="/apply"
            className="inline-flex min-h-11 items-center body-sm text-primary"
          >
            ← Funding Rounds
          </Link>
        }
      >
        <Skeleton
          className="h-9 w-3/4 motion-reduce:animate-none"
          aria-hidden="true"
        />
      </PageHeader>
      <p className="body-lg text-muted-foreground">
        Browse the application questions before you apply.
      </p>
      <div className="grid items-start gap-8 lg:grid-cols-[14rem_minmax(0,1fr)]">
        <div className="space-y-3" aria-hidden="true">
          <Skeleton className="h-6 w-3/4 motion-reduce:animate-none" />
          <Skeleton className="h-6 w-2/3 motion-reduce:animate-none" />
        </div>
        <ApplicationLoading layout="questions" />
      </div>
    </div>
  );
}
